import { useSuspenseQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'

export type LeadCallMethod = 'lynk' | 'user_phone' | 'calendly'

type UserFeaturePreferences = {
  leadCallMethod: LeadCallMethod
}

const getUserFeaturePreferences = async (userId: number): Promise<UserFeaturePreferences> => {
  try {
    const response = await getRequest<UserFeaturePreferences>(`/users/preferences/features?user_id=${userId}`)
    if (!response) {
      throw new Error('Feature preferences not found')
    }

    return response
  } catch (error) {
    throw new Error(`Failed to fetch feature preferences | ${error}`)
  }
}

export function useUserFeaturePreferences(userId: number) {
  return useSuspenseQuery({
    queryKey: ['user-feature-preferences', userId],
    queryFn: () => getUserFeaturePreferences(userId),
  })
}
